export default {"src":"/_next/static/media/WalletBuilderDark.7bd2dc55.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};